import { isVNode } from 'vue';

function getValidChildren(slots) {
  const slotArray = slots?.default?.() || [];
  return slotArray.filter((child) => isVNode(child));
}

export { getValidChildren };
